import Select from "react-select";
import React, {useState , useRef} from "react";

export default function PersonalInfos(){
    const [countries , setCountries]=useState([{ value :'Algérie' , label : 'Algérie'} , { value : 'Tunisie' , label : 'Tunisie'} ,  { label : 'France' , value : 'France'}]);
    const [selectedCountry , setSelectedCountry]=useState(null);

    return (
        <div>
            <div className="row mt-2 mb-4">
                <div className="col-sm-6">
                    <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Nom"
                    />
                </div>
                <div className="col-sm-6 mt-2 mt-sm-0">
                    <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Prénom"
                    />
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12 mb-2"> Pays :</div>
                <div className="col-12">
                    <div className="form-group">
                        <select value={selectedCountry} onChange={(e)=>setSelectedCountry(e.target.value)} className="form-control form-control-lg">
                            <option disabled selected value> -- Spécifiez votre pays -- </option>
                            {countries.map(country=><option value={country.value} key={country.value}>{country.label}</option>)}

                        </select>
                    </div>
                </div>
            </div>
            <div className="row mt-2 mb-4">
                <div className="col-12">
                    <div className="col-12 mb-2"> Votre numéro du téléphone :</div>
                    <input
                        type="tel"
                        className="form-control form-control-lg"
                        placeholder="eg : +213794614612"
                    />
                </div>
            </div>
        </div>
    )
}
